import React from 'react';
import styles from '../ReportCard.module.scss';

const AnalyticsSection = ({ statsLoading, statsData, blockedDrivers, blockedDriversLoading, blockedDriversError }) => {
  const inLoading = statsData?.in_loading_count || 0;
  const inRoute   = statsData?.in_route_count   || 0;
  const completed = statsData?.completed_count  || 0;
  const total     = inLoading + inRoute + completed;
  const blocked   = blockedDrivers?.length || 0;

  return (
    <div className={styles.analyticsSection}>
      {/* Header */}
      {/* <div className={styles.analyticsHeader}>
        <span className={styles.analyticsIcon}>📊</span>
        <div>
          <h2>Аналитика перевозок</h2>
          <p>Сводная статистика транспортной системы</p>
        </div>
      </div> */}

      {/* KPI strip */}
      <div className={styles.kpiStrip}>
        <div className={styles.kpiCard}>
          <div className={styles.kpiValue}>{statsLoading ? '—' : total}</div>
          <div className={styles.kpiLabel}>Всего активных</div>
          <div className={`${styles.kpiAccent} ${styles.kpiBlue}`}></div>
        </div>
        <div className={styles.kpiCard}>
          <div className={`${styles.kpiValue} ${styles.kpiAmber}`}>{statsLoading ? '—' : inLoading}</div>
          <div className={styles.kpiLabel}>В погрузке</div>
          <div className={`${styles.kpiAccent} ${styles.kpiAmberBg}`}></div>
        </div>
        <div className={styles.kpiCard}>
          <div className={`${styles.kpiValue} ${styles.kpiBlueTxt}`}>{statsLoading ? '—' : inRoute}</div>
          <div className={styles.kpiLabel}>В пути</div>
          <div className={`${styles.kpiAccent} ${styles.kpiBlue}`}></div>
        </div>
        <div className={styles.kpiCard}>
          <div className={`${styles.kpiValue} ${styles.kpiGreen}`}>{statsLoading ? '—' : completed}</div>
          <div className={styles.kpiLabel}>Завершили</div>
          <div className={`${styles.kpiAccent} ${styles.kpiGreenBg}`}></div>
        </div>
        <div className={styles.kpiCard}>
          <div className={`${styles.kpiValue} ${styles.kpiRed}`}>{blockedDriversLoading ? '—' : blocked}</div>
          <div className={styles.kpiLabel}>Заблокировано</div>
          <div className={`${styles.kpiAccent} ${styles.kpiRedBg}`}></div>
        </div>
      </div>

      {/* Main grid */}
      <div className={styles.analyticsGrid}>
        <div className={styles.analyticsCard}>
          <div className={styles.cardHeader}>
            <span className={styles.cardHeaderIcon}>🚛</span>
            <h3>Статус водителей</h3>
          </div>
          <div className={styles.chartContainer}>
            {statsLoading
              ? <div className={styles.noData}>Загрузка...</div>
              : <DriverStatusChart statsData={statsData} />}
          </div>
        </div>

        <div className={styles.analyticsCard}>
          <div className={styles.cardHeader}>
            <span className={styles.cardHeaderIcon}>🚫</span>
            <h3>Заблокированный транспорт</h3>
          </div>
          <div className={styles.blockedDriversTable}>
            {blockedDriversLoading && <div className={styles.noData}>Загрузка...</div>}
            {blockedDriversError && <div className={styles.noData} style={{ color: '#f87171' }}>{blockedDriversError}</div>}
            {!blockedDriversLoading && !blockedDriversError && <BlockedDriversTable drivers={blockedDrivers} />}
          </div>
        </div>

        <div className={styles.analyticsCard}>
          <div className={styles.cardHeader}>
            <span className={styles.cardHeaderIcon}>🏭</span>
            <h3>По базам</h3>
          </div>
          <div className={styles.chartContainer}>
            {statsLoading
              ? <div className={styles.noData}>Загрузка...</div>
              : <BaseStatsChart statsData={statsData} />}
          </div>
        </div>
      </div>
    </div>
  );
};

/** Круговая диаграмма: В погрузке / В пути / Завершили */
const DriverStatusChart = ({ statsData }) => {
  if (!statsData) return <div className={styles.noData}>Нет данных</div>;

  const inLoading = statsData.in_loading_count || 0;
  const inRoute   = statsData.in_route_count   || 0;
  const completed = statsData.completed_count  || 0;
  const total     = inLoading + inRoute + completed;
  if (total === 0) return <div className={styles.noData}>Нет данных</div>;

  const inLoadingArc = (inLoading  / total) * 502.6;
  const inRouteArc   = (inRoute    / total) * 502.6;
  const completedArc = (completed  / total) * 502.6;

  return (
    <>
      <svg viewBox="0 0 200 200" className={styles.pieChart}>
        <circle cx="100" cy="100" r="80" fill="none" stroke="#e9ecef" strokeWidth="36" />
        <circle cx="100" cy="100" r="80" fill="none" stroke="#f59e0b" strokeWidth="36"
          strokeDasharray={`${inLoadingArc} 502.6`} transform="rotate(-90 100 100)" />
        <circle cx="100" cy="100" r="80" fill="none" stroke="#0d6efd" strokeWidth="36"
          strokeDasharray={`${inRouteArc} 502.6`} strokeDashoffset={-inLoadingArc}
          transform="rotate(-90 100 100)" />
        <circle cx="100" cy="100" r="80" fill="none" stroke="#198754" strokeWidth="36"
          strokeDasharray={`${completedArc} 502.6`} strokeDashoffset={-(inLoadingArc + inRouteArc)}
          transform="rotate(-90 100 100)" />
        <text x="100" y="94" textAnchor="middle" fontSize="34" fontWeight="800" fill="#1e293b">{total}</text>
        <text x="100" y="114" textAnchor="middle" fontSize="11" fontWeight="600" fill="#6c757d" letterSpacing="1">ВСЕГО</text>
      </svg>
      <div className={styles.chartLegend}>
        <div className={styles.legendItem}>
          <span className={styles.legendColor} style={{ background: '#f59e0b' }}></span>
          <span className={styles.legendLabel}>В погрузке</span>
          <span className={styles.legendValue}>{inLoading}</span>
        </div>
        <div className={styles.legendItem}>
          <span className={styles.legendColor} style={{ background: '#0d6efd' }}></span>
          <span className={styles.legendLabel}>В пути</span>
          <span className={styles.legendValue}>{inRoute}</span>
        </div>
        <div className={styles.legendItem}>
          <span className={styles.legendColor} style={{ background: '#198754' }}></span>
          <span className={styles.legendLabel}>Завершили</span>
          <span className={styles.legendValue}>{completed}</span>
        </div>
      </div>
    </>
  );
};

/** Таблица заблокированных водителей */
const BlockedDriversTable = ({ drivers }) => {
  if (!drivers || drivers.length === 0) {
    return <div className={styles.noData}>Нет заблокированных водителей</div>;
  }
  return (
    <table className={styles.compactTable}>
      <thead>
        <tr>
          <th>№</th>
          <th>ФИО</th>
          <th>Номер машины</th>
          <th>Модель машины</th>
          <th>Дата блокировки</th>
        </tr>
      </thead>
      <tbody>
        {drivers.slice(0, 5).map((driver, idx) => (
          <tr key={idx}>
            <td>{idx + 1}</td>
            <td>{driver.employee_name || '-'}</td>
            <td>{driver.vehicle_number || '-'}</td>
            <td>{driver.vehicle_model || '-'}</td>
            <td>{driver.blocked_date || driver.time_b || driver.time_a || '-'}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

/** Круговая диаграмма + список по базам: В погрузке / Погружено / Отгружено */
const BaseStatsChart = ({ statsData }) => {
  if (!statsData || !statsData.base_stats) return <div className={styles.noData}>Нет данных</div>;

  const baseStats      = statsData.base_stats;
  const totalInLoading = Object.values(baseStats).reduce((sum, b) => sum + (b.in_loading || 0), 0);
  const totalLoaded    = Object.values(baseStats).reduce((sum, b) => sum + (b.loaded    || 0), 0);
  const totalDelivered = Object.values(baseStats).reduce((sum, b) => sum + (b.delivered || 0), 0);
  const total          = totalInLoading + totalLoaded + totalDelivered;
  if (total === 0) return <div className={styles.noData}>Нет данных</div>;

  const inLoadingArc = (totalInLoading / total) * 502.6;
  const loadedArc    = (totalLoaded    / total) * 502.6;
  const deliveredArc = (totalDelivered / total) * 502.6;

  return (
    <>
      <svg viewBox="0 0 200 200" className={styles.pieChart}>
        <circle cx="100" cy="100" r="80" fill="none" stroke="#e9ecef" strokeWidth="36" />
        <circle cx="100" cy="100" r="80" fill="none" stroke="#f59e0b" strokeWidth="36"
          strokeDasharray={`${inLoadingArc} 502.6`} transform="rotate(-90 100 100)" />
        <circle cx="100" cy="100" r="80" fill="none" stroke="#6f42c1" strokeWidth="36"
          strokeDasharray={`${loadedArc} 502.6`} strokeDashoffset={-inLoadingArc}
          transform="rotate(-90 100 100)" />
        <circle cx="100" cy="100" r="80" fill="none" stroke="#0dcaf0" strokeWidth="36"
          strokeDasharray={`${deliveredArc} 502.6`} strokeDashoffset={-(inLoadingArc + loadedArc)}
          transform="rotate(-90 100 100)" />
        <text x="100" y="94" textAnchor="middle" fontSize="34" fontWeight="800" fill="#1e293b">{total}</text>
        <text x="100" y="114" textAnchor="middle" fontSize="11" fontWeight="600" fill="#6c757d" letterSpacing="1">РЕЙСОВ</text>
      </svg>
      <div className={styles.chartLegend}>
        <div className={styles.legendItem}>
          <span className={styles.legendColor} style={{ background: '#f59e0b' }}></span>
          <span className={styles.legendLabel}>В погрузке</span>
          <span className={styles.legendValue}>{totalInLoading}</span>
        </div>
        <div className={styles.legendItem}>
          <span className={styles.legendColor} style={{ background: '#6f42c1' }}></span>
          <span className={styles.legendLabel}>В пути на базу</span>
          <span className={styles.legendValue}>{totalLoaded}</span>
        </div>
        <div className={styles.legendItem}>
          <span className={styles.legendColor} style={{ background: '#0dcaf0' }}></span>
          <span className={styles.legendLabel}>Отгружено</span>
          <span className={styles.legendValue}>{totalDelivered}</span>
        </div>
      </div>
      <div className={styles.basesList}>
        {Object.entries(baseStats).map(([name, stats]) => (
          <div key={name} className={styles.baseItem}>
            <div className={styles.baseName}>{name}</div>
            <div className={styles.baseStatsRow}>
              <span className={styles.statBadge} style={{ background: '#fff3cd', color: '#856404', border: '1px solid #ffc107' }}>{stats.in_loading || 0} погр-ся</span>
              <span className={styles.statBadge} style={{ background: '#ede9fe', color: '#6f42c1', border: '1px solid #c4b5fd' }}>{stats.loaded || 0} в пути</span>
              <span className={styles.statBadge} style={{ background: '#cff4fc', color: '#0a6589', border: '1px solid #0dcaf0'  }}>{stats.delivered || 0} отгр.</span>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default React.memo(AnalyticsSection);
